import { isTablet } from 'utils/general';

export default {
  props: {
    mobileId: String,
    desktopId: String,
  },
  computed: {
    iFrameSrc() {
      if (isTablet()) {
        if (this.mobileId) {
          return `https://player.vimeo.com/video/${this.mobileId}?background=1`;
        } else {
          return `https://player.vimeo.com/video/${this.desktopId}?background=1`;
        }
      } else {
        if (this.desktopId) {
          return `https://player.vimeo.com/video/${this.desktopId}?background=1`;
        } else {
          return `https://player.vimeo.com/video/${this.mobileId}?background=1`;
        }
      }
    },
  },
};
